import React, { Component } from 'react'

class OrderBy extends Component {
  render () {
    const { field, dir, current } = this.props
    if (field !== current) {
      return ''
    } else {
      return (
        <span className="order-by">
          {
            dir === 1 ? (
              <i className="fas fa-sort-up"></i>
            ) : (
              <i className="fas fa-sort-down"></i>
            )
          }
        </span>
      )
    }
  }
}

export default OrderBy
